import React, { Component } from 'react'
import './HomeGetInTouch.scss'

class HomeGetInTouch extends Component {

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return (
            <div className='home-get-in-touch'>
                <h2>{this.props.title}</h2>
                <p>{this.props.description}</p>
                <p>Address: {this.props.address}</p>
                <p>Phone: {this.props.phone}</p>
                <p>Email: {this.props.email}</p>
            </div>
        )
    }
}

export default HomeGetInTouch



// WEBPACK FOOTER //
// ./src/views/pages/Home2/HomeGetInTouch/index.js